module.exports = __webpack_public_path__ + "img/kefu-qrcode.da382113.png";